// Auto-generated from tweakcn theme-presets
// https://github.com/jnsahaj/tweakcn

export interface ThemePreview {
  key: string;
  label: string;
  primary: string;
  background: string;
  secondary: string;
  muted: string;
  accent: string;
}

export const THEME_PREVIEWS: ThemePreview[] = [
  {
    key: 'modern-minimal',
    label: 'Modern Minimal',
    primary: '#3b82f6',
    background: '#ffffff',
    secondary: '#f3f4f6',
    muted: '#f9fafb',
    accent: '#e0f2fe',
  },
  {
    key: 'violet-bloom',
    label: 'Violet Bloom',
    primary: '#7033ff',
    background: '#fdfdfd',
    secondary: '#edf0f4',
    muted: '#f5f5f5',
    accent: '#e2ebff',
  },
  {
    key: 't3-chat',
    label: 'T3 Chat',
    primary: '#a84370',
    background: '#faf5fa',
    secondary: '#f1c4e6',
    muted: '#f6e5f3',
    accent: '#f1c4e6',
  },
  {
    key: 'twitter',
    label: 'Twitter',
    primary: '#1e9df1',
    background: '#ffffff',
    secondary: '#0f1419',
    muted: '#E5E5E6',
    accent: '#E3ECF6',
  },
  {
    key: 'mocha-mousse',
    label: 'Mocha Mousse',
    primary: '#A37764',
    background: '#F1F0E5',
    secondary: '#BAAB92',
    muted: '#E4C7B8',
    accent: '#E4C7B8',
  },
  {
    key: 'bubblegum',
    label: 'Bubblegum',
    primary: '#d04f99',
    background: '#f6e6ee',
    secondary: '#8acfd1',
    muted: '#b2e1eb',
    accent: '#fbe2a7',
  },
  {
    key: 'amethyst-haze',
    label: 'Amethyst Haze',
    primary: '#8a79ab',
    background: '#f8f7fa',
    secondary: '#dfd9ec',
    muted: '#dcd9e3',
    accent: '#e6a5b8',
  },
  {
    key: 'notebook',
    label: 'Notebook',
    primary: '#606060',
    background: '#f9f9f9',
    secondary: '#dedede',
    muted: '#e3e3e3',
    accent: '#f3eac8',
  },
  {
    key: 'doom-64',
    label: 'Doom 64',
    primary: '#b71c1c',
    background: '#cccccc',
    secondary: '#556b2f',
    muted: '#b8b8b8',
    accent: '#4682b4',
  },
  {
    key: 'catppuccin',
    label: 'Catppuccin',
    primary: '#8839ef',
    background: '#eff1f5',
    secondary: '#ccd0da',
    muted: '#dce0e8',
    accent: '#04a5e5',
  },
  {
    key: 'graphite',
    label: 'Graphite',
    primary: '#606060',
    background: '#f0f0f0',
    secondary: '#e0e0e0',
    muted: '#d9d9d9',
    accent: '#c0c0c0',
  },
  {
    key: 'perpetuity',
    label: 'Perpetuity',
    primary: '#06858e',
    background: '#e8f0f0',
    secondary: '#d9eaea',
    muted: '#e0eaea',
    accent: '#c9e5e7',
  },
  {
    key: 'kodama-grove',
    label: 'Kodama Grove',
    primary: '#8d9d4f',
    background: '#e4d7b0',
    secondary: '#decea0',
    muted: '#decea0',
    accent: '#dbc894',
  },
  {
    key: 'cosmic-night',
    label: 'Cosmic Night',
    primary: '#6e56cf',
    background: '#f5f5ff',
    secondary: '#e4dfff',
    muted: '#f0f0fa',
    accent: '#d8e6ff',
  },
  {
    key: 'tangerine',
    label: 'Tangerine',
    primary: '#e05d38',
    background: '#e8ebed',
    secondary: '#f3f4f6',
    muted: '#f9fafb',
    accent: '#d6e4f0',
  },
  {
    key: 'quantum-rose',
    label: 'Quantum Rose',
    primary: '#e6067a',
    background: '#fff0f8',
    secondary: '#ffd6ff',
    muted: '#ffe3f2',
    accent: '#ffc1e3',
  },
  {
    key: 'nature',
    label: 'Nature',
    primary: '#2e7d32',
    background: '#f8f5f0',
    secondary: '#e8f5e9',
    muted: '#f0e9e0',
    accent: '#c8e6c9',
  },
  {
    key: 'bold-tech',
    label: 'Bold Tech',
    primary: '#8b5cf6',
    background: '#ffffff',
    secondary: '#f3f0ff',
    muted: '#f5f3ff',
    accent: '#dbeafe',
  },
  {
    key: 'elegant-luxury',
    label: 'Elegant Luxury',
    primary: '#9b2c2c',
    background: '#faf7f5',
    secondary: '#fdf2d6',
    muted: '#f0ebe8',
    accent: '#fef3c7',
  },
  {
    key: 'amber-minimal',
    label: 'Amber Minimal',
    primary: '#f59e0b',
    background: '#ffffff',
    secondary: '#f3f4f6',
    muted: '#f9fafb',
    accent: '#fffbeb',
  },
  {
    key: 'supabase',
    label: 'Supabase',
    primary: '#72e3ad',
    background: '#fcfcfc',
    secondary: '#fdfdfd',
    muted: '#ededed',
    accent: '#ededed',
  },
  {
    key: 'neo-brutalism',
    label: 'Neo Brutalism',
    primary: '#ff3333',
    background: '#ffffff',
    secondary: '#ffff00',
    muted: '#f0f0f0',
    accent: '#0066ff',
  },
  {
    key: 'solar-dusk',
    label: 'Solar Dusk',
    primary: '#B45309',
    background: '#FDFBF7',
    secondary: '#E4C090',
    muted: '#F1E9DA',
    accent: '#f2daba',
  },
  {
    key: 'claymorphism',
    label: 'Claymorphism',
    primary: '#6366f1',
    background: '#e7e5e4',
    secondary: '#d6d3d1',
    muted: '#e7e5e4',
    accent: '#f3e5f5',
  },
  {
    key: 'cyberpunk',
    label: 'Cyberpunk',
    primary: '#ff00c8',
    background: '#f8f9fa',
    secondary: '#f0f0ff',
    muted: '#f0f0ff',
    accent: '#00ffcc',
  },
  {
    key: 'pastel-dreams',
    label: 'Pastel Dreams',
    primary: '#a78bfa',
    background: '#f7f3f9',
    secondary: '#e9d8fd',
    muted: '#f3e8ff',
    accent: '#f3e5f5',
  },
  {
    key: 'clean-slate',
    label: 'Clean Slate',
    primary: '#6366f1',
    background: '#f8fafc',
    secondary: '#e5e7eb',
    muted: '#f3f4f6',
    accent: '#e0e7ff',
  },
  {
    key: 'caffeine',
    label: 'Caffeine',
    primary: '#644a40',
    background: '#f9f9f9',
    secondary: '#ffdfb5',
    muted: '#efefef',
    accent: '#e8e8e8',
  },
  {
    key: 'ocean-breeze',
    label: 'Ocean Breeze',
    primary: '#22c55e',
    background: '#f0f8ff',
    secondary: '#e0f2fe',
    muted: '#f3f4f6',
    accent: '#d1fae5',
  },
  {
    key: 'retro-arcade',
    label: 'Retro Arcade',
    primary: '#d33682',
    background: '#fdf6e3',
    secondary: '#2aa198',
    muted: '#93a1a1',
    accent: '#cb4b16',
  },
  {
    key: 'midnight-bloom',
    label: 'Midnight Bloom',
    primary: '#6c5ce7',
    background: '#f9f9f9',
    secondary: '#a1c9f2',
    muted: '#c9c4b5',
    accent: '#8b9467',
  },
  {
    key: 'candyland',
    label: 'Candyland',
    primary: '#ffc0cb',
    background: '#f7f9fa',
    secondary: '#87ceeb',
    muted: '#ddd9c4',
    accent: '#ffff00',
  },
  {
    key: 'northern-lights',
    label: 'Northern Lights',
    primary: '#34a85a',
    background: '#f9f9fa',
    secondary: '#6495ed',
    muted: '#ddd9c4',
    accent: '#66d9ef',
  },
  {
    key: 'vintage-paper',
    label: 'Vintage Paper',
    primary: '#a67c52',
    background: '#f5f1e6',
    secondary: '#e2d8c3',
    muted: '#ece5d8',
    accent: '#d4c8aa',
  },
  {
    key: 'sunset-horizon',
    label: 'Sunset Horizon',
    primary: '#ff7e5f',
    background: '#fff9f5',
    secondary: '#ffedea',
    muted: '#fff0eb',
    accent: '#feb47b',
  },
  {
    key: 'starry-night',
    label: 'Starry Night',
    primary: '#3a5ba0',
    background: '#f5f7fa',
    secondary: '#f7c873',
    muted: '#e5e5df',
    accent: '#6ea3c1',
  },
  {
    key: 'claude',
    label: 'Claude',
    primary: '#c96442',
    background: '#faf9f5',
    secondary: '#e9e6dc',
    muted: '#ede9de',
    accent: '#e9e6dc',
  },
  {
    key: 'vercel',
    label: 'Vercel',
    primary: 'oklch(0 0 0)',
    background: 'oklch(0.99 0 0)',
    secondary: 'oklch(0.94 0 0)',
    muted: 'oklch(0.97 0 0)',
    accent: 'oklch(0.94 0 0)',
  },
  {
    key: 'darkmatter',
    label: 'Darkmatter',
    primary: '#d87943',
    background: '#ffffff',
    secondary: '#527575',
    muted: '#f3f4f6',
    accent: '#eeeeee',
  },
  {
    key: 'mono',
    label: 'Mono',
    primary: '#737373',
    background: '#ffffff',
    secondary: '#f5f5f5',
    muted: '#f5f5f5',
    accent: '#f5f5f5',
  },
  {
    key: 'soft-pop',
    label: 'Soft Pop',
    primary: '#4f46e5',
    background: '#f7f9f3',
    secondary: '#14b8a6',
    muted: '#f0f0f0',
    accent: '#f59e0b',
  },
  {
    key: 'sage-garden',
    label: 'Sage Garden',
    primary: '#7c9082',
    background: '#f8f7f4',
    secondary: '#ced4bf',
    muted: '#e8e6e1',
    accent: '#bfc9bb',
  },
];

export const THEME_KEYS = THEME_PREVIEWS.map((t) => t.key);
